import React from "react"
import { useTranslate, Translate } from "ra-core"
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import {
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    FilterButton,
    SelectColumnsButton,
    ExportButton,
    TextField,
    ReferenceField,
    TextInput,
    DateField,
    usePermissions,
    FunctionField,
} from "react-admin"

const getDeviceFilters = (permissions: string, translate: Translate): React.ReactElement[] => {
    const filters = [
        <TextInput source="imei" label={translate("resources.devices.fields.imei")} />,
    ]
    if (permissions === "admin") {
        filters.push(<TextInput source="role" />)
    }
    return filters
}


const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)

const Listddt = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    return (
        <List
            resource={`devices/group/ddt/current+session`}
            queryOptions={{ refetchInterval: 60000 }}
            title={translate('resources.devicesddt.name')}
            filters={getDeviceFilters(permissions, translate)}
            //filterDefaultValues={{ role: "Device" }}
            sort={{ field: "created_at", order: "DESC" }}
            actions={<ListActions />}
        >
            <DatagridConfigurable
                bulkActionButtons={false}
                sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} >
                <ReferenceField label={translate("resources.devices.fields.imei")} source="id" reference="devices">
                    <TextField source="imei" label={translate("resources.devices.fields.imei")} />
                </ReferenceField>
                <ReferenceField label={translate("resources.devices.fields.object_id")} source="object_id" reference="objects" />
                <ReferenceField label={translate("resources.devices.fields.energy_kind_id")} source="energy_kind_id" reference="energy-kinds">
                    <TextField source="name" />
                </ReferenceField>
                <FunctionField
                    label={translate("resources.params.fields.p")}
                    render={(record: any) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {record?.val_p}
                            {record?.diff_p !== 0 ? (
                                record?.diff_p > 0 ? (
                                    <ArrowUpwardIcon style={{ color: "green" }} />
                                ) : (
                                    <ArrowDownwardIcon style={{ color: "red" }} />
                                )
                            ) : ""}
                        </div>
                    )}
                />
                <FunctionField
                    label={translate("resources.params.fields.t")}
                    render={(record: any) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {record?.val_t}
                            {record?.diff_t > 0 ? (
                                <ArrowUpwardIcon style={{ color: "green" }} />
                            ) : (
                                <ArrowDownwardIcon style={{ color: "red" }} />
                            )}
                        </div>
                    )}
                />
                <DateField showTime source="value_date" label={translate("resources.params.fields.value_date")}></DateField>
            </DatagridConfigurable>
        </List>
    )
}

export default Listddt